<script setup>
import AccountPicker from '@/components/AccountPicker.vue'
import { ref, watch } from 'vue'
import { useInstanceStore } from '@/store/backendInstances.js'
import { useSettingsStore } from '@/store/settings.ts'

const instanceStore = useInstanceStore()
const settingsStore = useSettingsStore()
const pickedAccountForPermissionSimulation = ref(null)

watch(pickedAccountForPermissionSimulation, async () => {
  if (!pickedAccountForPermissionSimulation.value) return
  const permissions = await instanceStore.getPermissionsOfAccount(pickedAccountForPermissionSimulation.value, undefined, undefined, true)
  settingsStore.simulatedPermissions = permissions.map(({ id }) => id)
})
</script>

<template>
  <v-combobox
    v-model="settingsStore.simulatedPermissions"
    class="my-2 w-100"
    :label="$t('settings.simulated_permissions')"
    hide-details
    variant="outlined"
    chips
    clearable
    closable-chips
    multiple
    :items="instanceStore.selectedInstance.availablePermissions"
  />

  <AccountPicker
    v-if="instanceStore.hasAllPermissions(['authentication.list_users', 'authorization.view'], undefined, true)"
    v-model="pickedAccountForPermissionSimulation"
    class="my-4 w-100"
    skip-permission-simulation
    :label="$t('settings.pick_from_account')"
  />
</template>

<style scoped></style>
